// extracted by mini-css-extract-plugin
module.exports = {"container":"gravity-left_container_2mKpJ","noDataBox":"gravity-left_noDataBox_2L9f6","icon":"gravity-left_icon_2E63s","chartBox":"gravity-left_chartBox_1Ir0B"};